import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";
import { currentLang } from "./i18n";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Solutions from "./pages/Solutions";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

function App() {
  const { i18n } = useTranslation();
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("lt_theme") || "light";
  });

  const lang = currentLang(i18n);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("lt_theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <HelmetProvider>
      <Router>
        <div className="site">
          <a href="#main" className="skip-link">
            Skip to content
          </a>
          <Navigation theme={theme} onThemeToggle={toggleTheme} />
          <main id="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer lang={lang} theme={theme} />
          <Analytics />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
